import auth from './modules/auth'
import evote from './modules/evote'

export default {
  auth,
  evote,
}
